/**
 * @packageDocumentation
 * @module api.functional.orders.approve
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponsenull } from "../../../structures/ServiceResponsenull";

/**
 * @controller PreorderController.approvePreorder
 * @path PATCH /orders/:id/approve
 * @accessor api.functional.orders.approve.approvePreorder
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function approvePreorder(
  connection: IConnection,
  id: string,
  customerId: string,
): Promise<approvePreorder.Output> {
  return PlainFetcher.fetch(connection, {
    ...approvePreorder.METADATA,
    template: approvePreorder.METADATA.path,
    path: approvePreorder.path(id, customerId),
  });
}
export namespace approvePreorder {
  export type Output = ServiceResponsenull;

  export const METADATA = {
    method: "PATCH",
    path: "/orders/:id/approve",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (id: string, customerId: string) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries({
      customerId: customerId,
    } as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = `/orders/${encodeURIComponent(id?.toString() ?? "null")}/approve`;
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}
